module.exports = "images/7ans.85b59fb8.png";